const AMOUNT_LONG_MULTIPLIER = 100000;

// used for BI events
export function amountToLong(amount: string): number {
  return Math.floor(Number(amount) * AMOUNT_LONG_MULTIPLIER);
}

// format money amount from "123456.7" to "123,456.70"
export function prettyAmount(amount: string): string {
  return Number(amount)
    .toFixed(2)
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// format money amount from "123456.7" to "123.456,70"
// used in Brazil
export function prettyAmountBrazil(amount: string): string {
  return Number(amount)
    .toFixed(2)
    .replace('.', ',')
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
